module.exports = __webpack_public_path__ + "img/2.77bf7766.jpg";